var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 40,
    viewBox: "0 0 108 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19294 13.7182C5.96948 13.0899 15.3164 10.1368 18.7153 5.23582C14.4667 4.45041 5.96948 5.23608 2.19294 13.7182Z",
    fill: "url(#paint0_linear_3777_6703)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 23.4069C0.587321 20.014 1.24881 16.546 1.72078 15.1322C9.27385 14.661 15.8828 11.8335 20.6034 5.70733C22.4917 6.17857 25.7962 8.5348 27.2124 9.94854C22.4917 13.7185 16.6754 14.9245 12.8988 16.3383C10.048 17.4055 3.86033 21.2078 1.34263 23.4069Z",
    fill: "url(#paint1_linear_3777_6703)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 30.4756C3.13698 28.3271 2.51334 26.8628 2.04127 25.2919C4.24424 23.4069 8.17814 20.1082 14.7871 17.752C19.5321 16.0603 23.4358 14.661 28.1565 11.3623C30.6426 13.7224 31.0807 17.6865 30.9889 19.3735C27.9992 20.0018 24.38 19.8447 16.6753 23.4069C12.3595 25.4024 11.1621 25.9709 5.81781 30.4756Z",
    fill: "url(#paint2_linear_3777_6703)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23401 31.8894C9.27385 33.9821 11.7915 34.1392 13.0504 34.4533C16.0716 28.0444 24.0653 27.8559 28.1565 28.3271C30.0448 25.9709 30.3595 22.9863 30.5168 21.2584C17.771 24.0859 11.4826 28.1194 7.23401 31.8894Z",
    fill: "url(#paint3_linear_3777_6703)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9386 34.9246C18.4005 35.2387 24.0967 34.7361 26.7403 30.2121C23.4358 29.7409 17.771 30.2121 14.9386 34.9246Z",
    fill: "url(#paint4_linear_3777_6703)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19294 13.7182C5.96948 13.0899 15.3164 10.1368 18.7153 5.23582C14.4667 4.45041 5.96948 5.23608 2.19294 13.7182Z",
    stroke: "url(#paint5_linear_3777_6703)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 23.4069C0.587321 20.014 1.24881 16.546 1.72078 15.1322C9.27385 14.661 15.8828 11.8335 20.6034 5.70733C22.4917 6.17857 25.7962 8.5348 27.2124 9.94854C22.4917 13.7185 16.6754 14.9245 12.8988 16.3383C10.048 17.4055 3.86033 21.2078 1.34263 23.4069Z",
    stroke: "url(#paint6_linear_3777_6703)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 30.4756C3.13698 28.3271 2.51334 26.8628 2.04127 25.2919C4.24424 23.4069 8.17814 20.1082 14.7871 17.752C19.5321 16.0603 23.4358 14.661 28.1565 11.3623C30.6426 13.7224 31.0807 17.6865 30.9889 19.3735C27.9992 20.0018 24.38 19.8447 16.6753 23.4069C12.3595 25.4024 11.1621 25.9709 5.81781 30.4756Z",
    stroke: "url(#paint7_linear_3777_6703)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23401 31.8894C9.27385 33.9821 11.7915 34.1392 13.0504 34.4533C16.0716 28.0444 24.0653 27.8559 28.1565 28.3271C30.0448 25.9709 30.3595 22.9863 30.5168 21.2584C17.771 24.0859 11.4826 28.1194 7.23401 31.8894Z",
    stroke: "url(#paint8_linear_3777_6703)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9386 34.9246C18.4005 35.2387 24.0967 34.7361 26.7403 30.2121C23.4358 29.7409 17.771 30.2121 14.9386 34.9246Z",
    stroke: "url(#paint9_linear_3777_6703)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 13.7182C5.96948 13.0899 15.3164 10.1368 18.7153 5.23582C14.4667 4.45041 5.96948 5.23608 2.19295 13.7182Z",
    fill: "#057DBE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 23.4069C0.587326 20.014 1.24882 16.546 1.72078 15.1322C9.27385 14.661 15.8828 11.8335 20.6035 5.70733C22.4917 6.17857 25.7962 8.5348 27.2124 9.94854C22.4917 13.7185 16.6754 14.9245 12.8989 16.3383C10.048 17.4055 3.86033 21.2078 1.34263 23.4069Z",
    fill: "#057DBE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 30.4756C3.13698 28.3271 2.51335 26.8628 2.04128 25.2919C4.24425 23.4069 8.17815 20.1082 14.7871 17.752C19.5321 16.0603 23.4359 14.661 28.1565 11.3623C30.6426 13.7224 31.0807 17.6865 30.9889 19.3735C27.9992 20.0018 24.38 19.8447 16.6754 23.4069C12.3595 25.4024 11.1621 25.9709 5.81781 30.4756Z",
    fill: "#057DBE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23401 31.8894C9.27385 33.9821 11.7915 34.1392 13.0504 34.4533C16.0716 28.0444 24.0653 27.8559 28.1565 28.3271C30.0448 25.9709 30.3595 22.9863 30.5169 21.2584C17.7711 24.0859 11.4826 28.1194 7.23401 31.8894Z",
    fill: "#057DBE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 13.7182C5.96948 13.0899 15.3164 10.1368 18.7153 5.23582C14.4667 4.45041 5.96948 5.23608 2.19295 13.7182Z",
    stroke: "#057DBE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 23.4069C0.587326 20.014 1.24882 16.546 1.72078 15.1322C9.27385 14.661 15.8828 11.8335 20.6035 5.70733C22.4917 6.17857 25.7962 8.5348 27.2124 9.94854C22.4917 13.7185 16.6754 14.9245 12.8989 16.3383C10.048 17.4055 3.86033 21.2078 1.34263 23.4069Z",
    stroke: "#057DBE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 30.4756C3.13698 28.3271 2.51335 26.8628 2.04128 25.2919C4.24425 23.4069 8.17815 20.1082 14.7871 17.752C19.5321 16.0603 23.4359 14.661 28.1565 11.3623C30.6426 13.7224 31.0807 17.6865 30.9889 19.3735C27.9992 20.0018 24.38 19.8447 16.6754 23.4069C12.3595 25.4024 11.1621 25.9709 5.81781 30.4756Z",
    stroke: "#057DBE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23401 31.8894C9.27385 33.9821 11.7915 34.1392 13.0504 34.4533C16.0716 28.0444 24.0653 27.8559 28.1565 28.3271C30.0448 25.9709 30.3595 22.9863 30.5169 21.2584C17.7711 24.0859 11.4826 28.1194 7.23401 31.8894Z",
    stroke: "#057DBE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 13.7182C5.96948 13.0899 15.3164 10.1368 18.7153 5.23582C14.4667 4.45041 5.96948 5.23608 2.19295 13.7182Z",
    fill: "#41B9C3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 23.4069C0.587326 20.014 1.24882 16.546 1.72078 15.1322C9.27385 14.661 15.8828 11.8335 20.6035 5.70733C22.4917 6.17857 25.7962 8.5348 27.2124 9.94854C22.4917 13.7185 16.6754 14.9245 12.8989 16.3383C10.048 17.4055 3.86033 21.2078 1.34263 23.4069Z",
    fill: "#41B9C3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 30.4756C3.13698 28.3271 2.51335 26.8628 2.04128 25.2919C4.24425 23.4069 8.17815 20.1082 14.7871 17.752C19.5321 16.0603 23.4359 14.661 28.1565 11.3623C30.6426 13.7224 31.0807 17.6865 30.9889 19.3735C27.9992 20.0018 24.38 19.8447 16.6754 23.4069C12.3595 25.4024 11.1621 25.9709 5.81781 30.4756Z",
    fill: "#41B9C3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 13.7182C5.96948 13.0899 15.3164 10.1368 18.7153 5.23582C14.4667 4.45041 5.96948 5.23608 2.19295 13.7182Z",
    stroke: "#41B9C3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 23.4069C0.587326 20.014 1.24882 16.546 1.72078 15.1322C9.27385 14.661 15.8828 11.8335 20.6035 5.70733C22.4917 6.17857 25.7962 8.5348 27.2124 9.94854C22.4917 13.7185 16.6754 14.9245 12.8989 16.3383C10.048 17.4055 3.86033 21.2078 1.34263 23.4069Z",
    stroke: "#41B9C3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81781 30.4756C3.13698 28.3271 2.51335 26.8628 2.04128 25.2919C4.24425 23.4069 8.17815 20.1082 14.7871 17.752C19.5321 16.0603 23.4359 14.661 28.1565 11.3623C30.6426 13.7224 31.0807 17.6865 30.9889 19.3735C27.9992 20.0018 24.38 19.8447 16.6754 23.4069C12.3595 25.4024 11.1621 25.9709 5.81781 30.4756Z",
    stroke: "#41B9C3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 13.7182C5.96948 13.0899 15.3164 10.1368 18.7153 5.23582C14.4667 4.45041 5.96948 5.23608 2.19295 13.7182Z",
    fill: "#5ABB7F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 23.4069C0.587326 20.014 1.24882 16.546 1.72078 15.1322C9.27385 14.661 15.8828 11.8335 20.6035 5.70733C22.4917 6.17857 25.7962 8.5348 27.2124 9.94854C22.4917 13.7185 16.6754 14.9245 12.8989 16.3383C10.048 17.4055 3.86033 21.2078 1.34263 23.4069Z",
    fill: "#5ABB7F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19295 13.7182C5.96948 13.0899 15.3164 10.1368 18.7153 5.23582C14.4667 4.45041 5.96948 5.23608 2.19295 13.7182Z",
    stroke: "#5ABB7F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34263 23.4069C0.587326 20.014 1.24882 16.546 1.72078 15.1322C9.27385 14.661 15.8828 11.8335 20.6035 5.70733C22.4917 6.17857 25.7962 8.5348 27.2124 9.94854C22.4917 13.7185 16.6754 14.9245 12.8989 16.3383C10.048 17.4055 3.86033 21.2078 1.34263 23.4069Z",
    stroke: "#5ABB7F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19141 13.7182C5.96794 13.0899 15.3149 10.1368 18.7137 5.23582C14.4651 4.45041 5.96794 5.23608 2.19141 13.7182Z",
    fill: "#8CBE28",
    stroke: "#8CBE28"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6293 27.288C45.3653 27.288 44.2693 27.048 43.3413 26.568C42.4293 26.072 41.7253 25.408 41.2293 24.576C40.7333 23.728 40.4853 22.792 40.4853 21.768V14.688H44.2053V21.672C44.2053 22.104 44.3093 22.504 44.5173 22.872C44.7253 23.224 45.0053 23.512 45.3573 23.736C45.7253 23.944 46.1413 24.048 46.6053 24.048C47.0533 24.048 47.4533 23.944 47.8053 23.736C48.1733 23.512 48.4613 23.224 48.6693 22.872C48.8773 22.504 48.9813 22.104 48.9813 21.672V14.688H52.7013V21.768C52.7013 22.792 52.4613 23.728 51.9813 24.576C51.5013 25.408 50.8053 26.072 49.8933 26.568C48.9973 27.048 47.9093 27.288 46.6293 27.288ZM54.9813 27V18.312C54.9813 17.192 55.3013 16.312 55.9413 15.672C56.5813 15.032 57.4693 14.712 58.6053 14.712H62.1813V17.736H59.5173C59.2933 17.736 59.1013 17.816 58.9413 17.976C58.7813 18.12 58.7013 18.312 58.7013 18.552V27H54.9813ZM69.939 27.288C68.611 27.288 67.451 27.016 66.459 26.472C65.467 25.928 64.699 25.152 64.155 24.144C63.611 23.136 63.339 21.96 63.339 20.616V9.48H67.059V16.032H67.131C67.371 15.696 67.667 15.408 68.019 15.168C68.387 14.912 68.787 14.72 69.219 14.592C69.667 14.464 70.139 14.4 70.635 14.4C71.803 14.4 72.827 14.664 73.707 15.192C74.587 15.72 75.275 16.448 75.771 17.376C76.283 18.304 76.539 19.392 76.539 20.64C76.539 21.6 76.387 22.488 76.083 23.304C75.779 24.12 75.339 24.832 74.763 25.44C74.203 26.032 73.515 26.488 72.699 26.808C71.899 27.128 70.979 27.288 69.939 27.288ZM69.939 24.072C70.515 24.072 71.011 23.936 71.427 23.664C71.843 23.376 72.163 22.992 72.387 22.512C72.627 22.016 72.747 21.464 72.747 20.856C72.747 20.248 72.627 19.704 72.387 19.224C72.163 18.744 71.843 18.368 71.427 18.096C71.011 17.808 70.515 17.664 69.939 17.664C69.363 17.664 68.859 17.808 68.427 18.096C68.011 18.368 67.691 18.744 67.467 19.224C67.243 19.704 67.131 20.248 67.131 20.856C67.131 21.464 67.243 22.016 67.467 22.512C67.691 22.992 68.011 23.376 68.427 23.664C68.859 23.936 69.363 24.072 69.939 24.072ZM83.2757 27.288C82.1877 27.288 81.2277 27.008 80.3957 26.448C79.5637 25.888 78.9157 25.136 78.4517 24.192C77.9877 23.232 77.7557 22.152 77.7557 20.952C77.7557 19.704 78.0277 18.592 78.5717 17.616C79.1157 16.624 79.8837 15.84 80.8757 15.264C81.8837 14.688 83.0677 14.4 84.4277 14.4C85.8037 14.4 86.9717 14.688 87.9317 15.264C88.9077 15.824 89.6517 16.6 90.1637 17.592C90.6917 18.568 90.9557 19.664 90.9557 20.88V27H87.3077V25.032H87.2117C86.9877 25.464 86.6997 25.856 86.3477 26.208C85.9957 26.544 85.5637 26.808 85.0517 27C84.5557 27.192 83.9637 27.288 83.2757 27.288ZM84.3797 24.072C84.9397 24.072 85.4277 23.936 85.8437 23.664C86.2757 23.376 86.6037 22.984 86.8277 22.488C87.0517 21.992 87.1637 21.44 87.1637 20.832C87.1637 20.24 87.0517 19.704 86.8277 19.224C86.6037 18.744 86.2757 18.368 85.8437 18.096C85.4277 17.808 84.9397 17.664 84.3797 17.664C83.8037 17.664 83.2997 17.808 82.8677 18.096C82.4357 18.368 82.1077 18.744 81.8837 19.224C81.6597 19.704 81.5477 20.24 81.5477 20.832C81.5477 21.44 81.6597 21.992 81.8837 22.488C82.1077 22.984 82.4357 23.376 82.8677 23.664C83.2997 23.936 83.8037 24.072 84.3797 24.072ZM93.2987 27V19.92C93.2987 18.896 93.5467 17.968 94.0427 17.136C94.5387 16.304 95.2427 15.64 96.1547 15.144C97.0827 14.648 98.1787 14.4 99.4427 14.4C100.723 14.4 101.811 14.648 102.707 15.144C103.619 15.64 104.315 16.304 104.795 17.136C105.275 17.968 105.515 18.896 105.515 19.92V27H101.795V20.016C101.795 19.584 101.691 19.192 101.483 18.84C101.275 18.472 100.987 18.184 100.619 17.976C100.267 17.752 99.8667 17.64 99.4187 17.64C98.9547 17.64 98.5387 17.752 98.1707 17.976C97.8187 18.184 97.5387 18.472 97.3307 18.84C97.1227 19.192 97.0187 19.584 97.0187 20.016V27H93.2987Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3777_6703",
    x1: 16.8269,
    y1: 28.7984,
    x2: 24.3677,
    y2: 35.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3777_6703",
    x1: 16.8269,
    y1: 28.7984,
    x2: 24.3677,
    y2: 35.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3777_6703",
    x1: 16.8269,
    y1: 28.7984,
    x2: 24.3677,
    y2: 35.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3777_6703",
    x1: 16.8269,
    y1: 28.7984,
    x2: 24.3677,
    y2: 35.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3777_6703",
    x1: 16.8269,
    y1: 28.7984,
    x2: 24.3677,
    y2: 35.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3777_6703",
    x1: 18.7152,
    y1: 29.2696,
    x2: 23.4262,
    y2: 34.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3777_6703",
    x1: 18.7152,
    y1: 29.2696,
    x2: 23.4262,
    y2: 34.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3777_6703",
    x1: 18.7152,
    y1: 29.2696,
    x2: 23.4262,
    y2: 34.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3777_6703",
    x1: 18.7152,
    y1: 29.2696,
    x2: 23.4262,
    y2: 34.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3777_6703",
    x1: 18.7152,
    y1: 29.2696,
    x2: 23.4262,
    y2: 34.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C51A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B22FB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c3fb34adee07b23a45c6f01eac789941.svg";
export { ForwardRef as ReactComponent };